import React, { Component } from 'react'
import { aUsers } from 'utils/aUtils'
import DataSyncTable from 'components/dataSyncTable'
import DataTable from 'components/dataTable'

export default class UserTable extends Component {

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const CellType = DataTable.CellType
    const map = { admin: '管理者', manager: '主管', user: '普通', disabled: '停用' }
    const schemas = [
      { type: CellType.input, title: '帳號', key: 'account', width: '5em' },
      { type: CellType.input, title: '姓名', key: 'name', width: '7em' },
      { type: CellType.dropDown, title: '權限', key: 'role', width: '5em', map },
      { type: CellType.password, title: '密碼', key: 'password', width: '10em', map },
    ]

    return (
      <DataSyncTable
        dataUtil={aUsers}
        schemas={schemas}
        radioKey="role"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/userTable.jsx